import React from 'react';
import {connect} from 'react-redux';
import cs from 'classnames';
import {push as changeURL} from 'react-router-redux';
import isEmpty from 'lodash/isEmpty';
import trim from 'lodash/trim';
import includes from 'lodash/includes';
import format from 'date-fns/format';
import {getFetchedJSON} from '~/misc/fetch';

import mapDispatch from '~/misc/mapDispatch';
import store from '~/store';
import {modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
import AccountHeader from '../MyAccount/share/AccountHeader';
import ResetPassword from '../MyAccount/share/ResetPassword';
import Input from '../MyAccount/share/Input';
import SiderBarController from '../MyAccount/share/SiderBar';
import Button from '~/components/common/Button';
import Spinner from '~/components/common/Spinner';
import {saveUserPageContactInfo, hideAsyncErrorMessage} from '~/modules/userAccountPage/actions';
import {hideChangePasswordAsyncErrorMessage} from '~/modules/user/actions';
import {hideErrorMsg} from '~/misc/hideErrorMsg';
import {regEmail, regPhone, regPassWord, regDot, regMc} from '~/misc/reg';
import {errorInfoConfig} from '~/misc/error-info';
import {changePassword} from '~/modules/user/actions';
import {formatPhone, formatNumberOnly} from '~/misc/formatPhone';
import {track} from '~/misc/metrics';

import css from './index.css';
import sharedCSS from '~/components/shared.css';
import siderBarCss from '~/components/pages/MyAccount/index.css'

const routeConfig = {
  route: {
    'user': 0,
    'dot-verify': 1
  },
  path: 'free-account',
  index: 'user'
}
class FreeAccount extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    track('my account', {'My account - homepage': 1});
    if (!this.props.user.token
      // || (this.props.account.userInfo.data && this.props.account.userInfo.data.memberPlan !== 'Free')
    ) {
      this.props.goToRoot();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.user.id && (this.props.user.id !== nextProps.user.id)
      // || (this.props.account.userInfo.data && this.props.account.userInfo.data.memberPlan !== 'Free')
      // || (nextProps.account.userInfo.data && nextProps.account.userInfo.data.memberPlan !== 'Free')
    ) {
      this.props.goToRoot();
    }
  }
  render() {
    return (
      <div className={cs(sharedCSS.widewrap, 'qa-content')}>
        <div className={cs(sharedCSS.wideStretchable, siderBarCss.wrap)}>
          <SiderBarController className={cs(siderBarCss.siderBar)} props={this.state} config={routeConfig}>
            <div
              className={cs(siderBarCss.linkList)}
              fn={this.props.goToAccountProfile}
              title='Account Information'
              data-qa='Account-profile-link'
            />
            <div
              className={cs(siderBarCss.linkList)}
              fn={this.props.goToDotVerify}
              title='Carrier Verification'
              data-qa='Dot-verify-link'
            />
          </SiderBarController>
          <div className={cs(siderBarCss.content)}>
            {this.renderContent()}
          </div>
        </div>
      </div>
    );
  }

  renderContent() {
    const userAccountInfo = this.props.account.userInfo;
    const childrenWithProps = React.Children.map(
      this.props.children,
      (child) => React.cloneElement(
        child,
        {
          user: this.props.user,
          account: this.props.account,
          adminAccountPage: this.props.adminAccountPage,
        }
      )
    );
    if (userAccountInfo.error) {
      return (
        <div className={cs(css.removeBg, css.center)}>
          {userAccountInfo.error}
        </div>
      );
    }
    if (!isEmpty(userAccountInfo.data)) {
      return <div>{childrenWithProps}</div>;
    }
    return (
      <div className={css.spinnerLine}>
        <div className={css.spinner}>
          <Spinner scalable={true}/>
        </div>
      </div>
    );
  }
}

export default connect(
  ({user, userAccountPage, account, dots}) => ({user, userAccountPage, account, dots}
), mapDispatch({
  login: () => modalChange(modes.LOGIN, 'user-account'),
  signup: () => modalChange(modes.SIGNUP, 'user-account'),
  goToRoot: () => changeURL('/'),
  goToAccountProfile: () => changeURL('/free-account'),
  goToDotVerify: () => changeURL('/free-account/dot-verify'),
  
}))(FreeAccount);



// WEBPACK FOOTER //
// ./src/components/pages/FreeAccount/index.js